import { Alert } from "@volca/ui/components/ui/alert";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface RosterReassignmentAlertProps {
  count: number;
}

export const RosterReassignmentAlert = ({
  count,
}: RosterReassignmentAlertProps) => (
  <Alert color="danger" className="shrink-0">
    <Stack align="start" gap={1}>
      <Text variant="label">
        {count} {count === 1 ? "person needs" : "people need"} attention
      </Text>
      <Text variant="caption" tone="muted">
        A field or pay plan changed and their saved value is no longer valid.
        Open each flagged person and pick a new value before publishing.
      </Text>
    </Stack>
  </Alert>
);
